import { imageUrlToBlob, renderPositionForVGBImage, scalePosition } from 'collections/watch-me-grow/components/ImageEditor/helper';
import useEntity from 'entities/hooks/use-entity';
import React, { memo, useState, useEffect } from 'react';
import { Image, Box } from 'rebass';
import ReactAvatarEditor from 'react-avatar-editor';

function getOrientation(width, height) {
  if (width > height) return 'landscape';
  if (height > width) return 'portrait';
  return 'square';
}

export const RenderChild = (
  { relationships, width, height, ...props }
) => {

  const { entity: originalImage } = useEntity({ type: 'images', id: relationships?.['photo']?.data?.id });
  const [newImageObj, setNewImageObj] = useState(null);
  const [scale, setScale] = useState(0);
  const [photoScaling, setPhotoScalling] = useState(null);

  const photoLayer = props?.attributes

  useEffect(() => {
    if (photoLayer) {
      if (photoLayer?.width && photoLayer?.left !== null && photoLayer?.top !== null)
        setPhotoScalling({
          x: photoLayer?.left / (photoLayer?.width || 1),
          y: photoLayer?.top / (photoLayer?.height || 1),
        });
      setScale(photoLayer?.scale || 1);
    }
  }, [photoLayer]);

  const handleChange = async (url) => {

    // Blob/object URLs are already local — skip imageUrlToBlob to avoid axios issues
    if (url.startsWith('blob:') || url.startsWith('data:')) {
      setNewImageObj(url);
      return;
    }
    try {
      const blob = await imageUrlToBlob(url);
      setNewImageObj(URL.createObjectURL(blob));
    } catch (err) {
      setNewImageObj(url);
    }
  };
  useEffect(() => {
    const url = originalImage?.tmpURL || originalImage?.['image-versions']?.[4]?.url

    if (url)
      handleChange(url);
  }, [originalImage?.id]);

  if (!newImageObj) return null;

  return <Box sx={{ zIndex: props?.attributes?.['render-order'] }} id={newImageObj}>
    <ReactAvatarEditor
      image={newImageObj}
      height={height}
      width={width}
      color={[250, 250, 250, 1]}
      scale={(+scalePosition(scale) * 3) / 100}
      position={renderPositionForVGBImage(photoScaling)}

      crossOrigin="anonymous"
      style={{
        position: 'absolute',
        height: `${height}px`,
        top: 0,
        left: -25, // should match with the left value in Editor.js of frameSrc for proper alignment
        objectFit: 'cover',
      }}
    />
  </Box>
}

function ImageLayer({
  photo,
  destinationImageSrcExists,
  onImageReady,
  renderedAsChild,
  tempURL,
  randomBorder,
  isFromBookCover,
  layerId,
  selectedLayer,
  children,
  ...props
}) {
  const { entity: imageSrc } = useEntity(photo || {});
  const { entity: pageLayeerToSelect } = useEntity(props?.['event-destination-layer'])

  const [fileSrc, setFileSrc] = useState(imageSrc?.['asset-url']);
  const imageOrientation = getOrientation(imageSrc?.width, imageSrc?.height)

  const [error, setError] = useState(false);
  useEffect(() => {
    setFileSrc(imageSrc?.type === 'Video' ? imageSrc?.['preview-url'] : imageSrc?.['asset-url']);
  }, [imageSrc]);

  const doeshaveChildren = children?.length > 0

  return (<>
    {selectedLayer && selectedLayer?.id === layerId && <Box
      width={`${props.width}px`}
      height={`${props.height}px`}
      bg='rgba(125, 194, 255, 0.50)' sx={{
        position: 'absolute',
        top: `${props.ypos}px`,
        left: `${props.xpos}px`,
        zIndex: props['render-order'] + 1,
      }} />}
    <Box
      id={props?.id}
      onClick={props?.onMediaClick && props?.pageId === props?.currentPage?.id ? () => props?.onMediaClick({ ...pageLayeerToSelect, photo }) : undefined}
      width={`${props.width}px`}
      height={`${props.height}px`}
      sx={{
        position: renderedAsChild ? 'relative' : 'absolute',
        top: `${props.ypos}px`,
        left: `${props.xpos}px`,
        zIndex: props['render-order'],
        writingMode: 'horizontal-tb',
        touchAction: 'pan-x pan-y pinch-zoom',
        border: randomBorder,
        // bg: (isFrameLayer && !destinationImageSrcExists) ? '#F5EEF8' : 'transparent',
        // cursor: 'pointer',
      }}
    >
      {doeshaveChildren && children.map((ch) => !!ch?.relationships?.photo && <RenderChild key={ch.id} height={props?.height} width={props?.width} {...ch} />)}

      {Object.keys(imageSrc).length === 0 ?
        <Box sx={{
          bg: 'transparent'
        }} />
        : <Image
          src={tempURL || fileSrc}
          id={props?.id}
          sx={{
            position: 'absolute',
            top: 0,
            left: doeshaveChildren ? '-3px' : 0,
            zIndex: props['render-order'],
            objectFit: 'cover',
            cursor: 'pointer !important',
          }}
          height={props.height + (doeshaveChildren ? 5 : 0)}
          minWidth={props.width + (doeshaveChildren ? 7 : 0)}
          loading="lazy"
          onError={(e) => {
            // if (fileSrc === image) setFileSrc(secondUrl);
            const { target } = e; // The image element that triggered the error
            setError(true)
            if (target.naturalWidth === 0) {
              console.log('Image not found or failed to load.');
            } else {
              console.log('Error loading image:', e);
            }
          }}
          onLoad={onImageReady}
        />}
    </Box>
  </>
  );
}

export default memo(ImageLayer);
